import React from 'react'

import { Loader } from '@web/walter-ui-kit'
import styles from './style.module.css'

export default function Preloader() {
    return (
        <div className={styles.preloader}>
            <Loader />
        </div>
    )
}
